import { everest } from '~/services/serviceInstances';

type ServerResponse = {
  data: {
    id: string;
    type: string;
    attributes: { code: string };
  }[];
  meta: { total: number };
};

/**
 * The catalogue is already sorted and complete — Workday returns it in one
 * response, so there is nothing to page through — and the code is the only
 * attribute on the wire, which is also the resource id.
 */
const mapResponse = (serverResponse: ServerResponse): string[] =>
  serverResponse.data.map((currency) => currency.attributes.code);

/**
 * The tenant's Workday currency catalogue. K2 serves the same list from
 * `GET /integrate-workflow/currencies`, but gated behind
 * CLM_EVOLUTION_PHASE_1; Everest has no such gate, so surfaces that a
 * pre-CLM-Evolution tenant reaches read it from here (EKP-61735).
 */
export const getCurrencies = async (): Promise<string[]> => {
  const serverResponse: ServerResponse = await everest.get('/currencies');
  return mapResponse(serverResponse);
};
